// extracted by mini-css-extract-plugin
export var borderRadius = "_b8-4";
export var large = "_b8-3";
export var logoContainer = "_b8-0";
export var nameLogo = "_b8-2";
export var small = "_b8-1";